
export enum ColClasses {
  TINIEST = 'col-md-2 col-sm-3',
  TINY = 'col-md-3 col-sm-4',
  SMALL = 'col-md-4 col-sm-6',
  MEDIUM = 'col-md-6',
  LARGE = 'col-md-12'
}

export enum Colors {
  BLUE = '#4158D0',
  PINK = '#C850C0',
  ORANGE = '#FFCC70',
  WHITE = '#ffffff',
}

export enum StorageKeys {
  TOKEN = 'token',
  CURRENT_USER = 'current_user'
}